import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/salesCopy';
function Avatar({
  initials
}: {
  initials: string;
}) {
  return <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-rust-soft text-xs font-semibold tracking-[0.06em] text-rust-dark" data-id="element-231" data-mp="hqiydhejmgm">
      {initials}
    </span>;
}
export function TestimonialWall() {
  const [featured, ...rest] = testimonials;
  return <section className="w-full border-b border-line bg-surface" data-id="element-232" data-mp="3duivxhivdgz1">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-5 sm:py-16 lg:py-20" data-id="element-233" data-mp="3dvty5cwo2go1">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between sm:gap-4" data-id="element-234" data-mp="2zw2o1n99tkfb">
          <div data-id="element-235" data-mp="33x4djcddyi43">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-236" data-mp="33wmlkrxraq1z">
              Trusted by piano and guitar teachers
            </p>
            <h2 className="mt-3 font-display text-2xl font-semibold leading-tight tracking-tight text-ink sm:mt-4 sm:text-4xl" data-id="element-237" data-mp="123ye26e2xgge">
              What teachers are saying
            </h2>
          </div>
          <p className="flex items-center gap-2 text-[13px] font-medium text-ink-muted sm:text-sm" data-id="element-238" data-mp="1rmxhyp8zy2az">
            <StarIcon className="h-4 w-4 fill-rust text-rust" aria-hidden="true" data-id="element-239" data-mp="26btlqa40st5s" />
            Studios, academies and private teachers
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:mt-12 sm:gap-6 lg:grid-cols-3" data-id="element-240" data-mp="1do7mtf5qmcp9">
          <figure className="flex h-full flex-col rounded-2xl bg-ink p-6 text-paper sm:p-8 lg:row-span-2" data-id="element-241" data-mp="1dq0rwq0pcov5">
            <blockquote className="font-display text-xl font-medium leading-snug sm:text-[1.75rem]" data-id="element-242" data-mp="1nmdmrr7zh8rh">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6 sm:pt-8" data-id="element-243" data-mp="1ilpl8bm4p9j0">
              <span aria-hidden="true" className="flex h-10 w-10 items-center justify-center rounded-full bg-paper/10 text-xs font-semibold text-paper" data-id="element-244" data-mp="2z0haifnza0o3">
                {featured.initials}
              </span>
              <span className="text-sm" data-id="element-245" data-mp="364qldgs3yreh">
                <span className="block font-semibold" data-id="element-246" data-mp="363p6t2bvvms0">{featured.name}</span>
                <span className="block text-paper/60" data-id="element-247" data-mp="3b3abzuhncrd6">{featured.role}</span>
              </span>
            </figcaption>
          </figure>

          {rest.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-line bg-paper p-5 sm:p-7" data-id="element-248" data-mp="2if620ws1ls4o">
              <blockquote className="text-[15px] leading-relaxed text-ink-soft" data-id="element-249" data-mp="2neqzt3vh7uft">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5 sm:pt-6" data-id="element-250" data-mp="2x428wqid4z3p">
                <Avatar initials={item.initials} data-id="element-251" data-mp="2x5vfy6ww1lc8" />
                <span className="text-sm" data-id="element-252" data-mp="1znln2xku1i9q">
                  <span className="block font-semibold text-ink" data-id="element-253" data-mp="1zmka2nk9alpd">{item.name}</span>
                  <span className="block text-ink-muted" data-id="element-254" data-mp="24lwwj777tqrf">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}